import { Routes, Route, useNavigate, useParams, useLocation } from "react-router-dom";
import './history.scss';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Band from "../../components/band/band";
import BandsByCategory from "../../components/band/bandsByCategory";
import Spinner from './../../assets/images/spinner.svg'
import { STRAPI_URL } from "../../config/env";

/**
 * Timeout (in Millisekunden), nachdem ein Rerender erfolgt sein sollte.
 */
const RENDER_TIMEOUT = 200

export default function Bands(props) {
  const location = useLocation()
  const path = '/history';
  const pathParams = useParams()
  const navigate = useNavigate()
  const showNewBands = props.homepageData?.showNewBands
  const filtersReady = typeof showNewBands !== 'undefined' || Object.keys(props.homepageData ?? {}).length > 0
  const [bandData, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!filtersReady) {
      setLoading(true)
      return
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(`${STRAPI_URL}/api/bands-rig?populate=*`);
        const bandData = response.data;
        bandData.sort(compareBands)
        setData(bandData);
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    }
    fetchData();
  }, [setData, path, filtersReady]);

  // Navigiere automatisch zur ersten Band, wenn keine Band ausgewählt ist
  useEffect(() => {
    let scrollTimeout;
    if (!pathParams['*'] && bandData.length > 0) {
      navigate(`${path}${bandData[0].attributes.rigUrl}`)
      // Warte Rerender ab un scrolle dann zur Bandbox (funktioniert nicht über `navigate` Funktion)
      scrollTimeout = setTimeout(() => {
        const bandBox = document.getElementById('bandbox')
        if (bandBox) {
          bandBox.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, RENDER_TIMEOUT);
    }
    // path, pathParams und navigate Navigate sind zwar technisch gesehen Dependencies des Hooks,
    // effektiv ausgeführt werden soll dieser aber erst *nachdem* bandData (neu) geladen wurde.
    // Ansonsten gibt es beim Wechsel zwischen /bands, /history und /akustik Probleme, weil versucht
    // wird eine Band anzuzeigen, die nicht mehr in bandData enthalten ist.
    return () => clearTimeout(scrollTimeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bandData])

  const bandExists = bandData.find(x => path + x.attributes.rigUrl === location.pathname)
  return (
    <div className="bandsSection">
      <div className="categoryNavigation">
        {!loading && filtersReady && <BandsByCategory bandData={bandData} path={path} showNewBands={showNewBands} />}
        {(loading || !filtersReady) && <div className='loading'><img src={Spinner} alt="loading animation" /></div>}
      </div>
      <div id='bandbox'></div>
      <Routes>
        {!loading && filtersReady && bandExists && <Route path=":id" element={<Band path={path} bandData={bandData} />} />}
      </Routes>
    </div>
  )
}

function compareBands(a, b) {
  if (a.attributes.sort < b.attributes.sort) {
    return -1;
  }
  if (a.attributes.sort > b.attributes.sort) {
    return 1;
  }
  return 0;
}

